export type TripRefreshReason = 'allocated' | 'unassigned' | 'cancelled' | 'changed';

export type TripRefreshEvent = {
  reason: TripRefreshReason;
  bookingId?: string;
};

const EVENT_NAME = 'fleetup:trip-refresh';

/**
 * Small app-local event bus for operational schedule changes. Push handling,
 * foreground/resume checks, and trip screens use the same signal so an
 * allocation change refreshes every mounted consumer instead of only updating
 * the notification bell.
 */
export function notifyTripRefresh(detail: TripRefreshEvent): void {
  window.dispatchEvent(new CustomEvent<TripRefreshEvent>(EVENT_NAME, { detail }));
}

export function onTripRefresh(handler: (event: TripRefreshEvent) => void): () => void {
  const listener = (event: Event) => handler((event as CustomEvent<TripRefreshEvent>).detail);
  window.addEventListener(EVENT_NAME, listener);
  return () => window.removeEventListener(EVENT_NAME, listener);
}
